/**
 * components/branch/HeadOfficeProductNote.js
 *
 * The note on an "add a product" form for a team member limited to some
 * branches (4 Oct 2026). Adding products is head office's, so the form is
 * locked for them; without a word it just looks broken. The edit forms say
 * the same through useProductFormGate().readOnlyMessage.
 *
 *   const gate = useProductFormGate(busy);
 *   <HeadOfficeProductNote gate={gate} />
 */
import React from "react";
import "./branch.css";

export const HEAD_OFFICE_ADDS_PRODUCTS =
  "Only head office can add products. To switch a product off or mark it sold out at your branch, use the Branches tab.";

export default function HeadOfficeProductNote({ gate }) {
  if (!gate?.readOnly || !gate?.branchLocked) return null;
  return (
    <div className="lk-note lk-note--warning" style={{ marginBottom: 16 }}>
      <i className="fa fa-store" aria-hidden="true" style={{ marginTop: 2 }} />
      <span>{HEAD_OFFICE_ADDS_PRODUCTS}</span>
    </div>
  );
}
